export default "__VITE_ASSET__BSvzHQZf__"